enum NotificationStyles {
  NONE = 'none',
  SUCCESS = 'success',
  WARNING = 'warning',
  ERROR = 'error',
  INFO = 'info',
}

export { NotificationStyles };
